/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';

const IconInfo = () => (
  <svg width="36px" height="36px" viewBox="0 0 36 36" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g>
        <g>
          <circle id="Circle" strokeOpacity="0.3" stroke="#111111" cx="18" cy="18" r="10.5" />
          <path
            fillOpacity="0.3"
            fill="#111111"
            d="M17,23 L17,16 L16,16 L16,15 L19,15 L19,15.5 L19,23 L20,23 L20,24 L16,24 L16,23 L17,23 Z M18,14 C17.3096441,14 16.75,13.4403559 16.75,12.75 C16.75,12.0596441 17.3096441,11.5 18,11.5 C18.6903559,11.5 19.25,12.0596441 19.25,12.75 C19.25,13.4403559 18.6903559,14 18,14 Z"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default IconInfo;
